(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-colour-match"] && !Shopify.designMode) return;
  try {
    
class LumaColourMatch{constructor(root){this.root=root;this.input=root.querySelector('[data-file-input]');this.upload=root.querySelector('[data-upload-panel]');this.workspace=root.querySelector('[data-workspace]');this.canvas=root.querySelector('[data-canvas]');this.ctx=this.canvas.getContext('2d',{willReadFrequently:true});this.results=root.querySelector('[data-results]');this.swatch=root.querySelector('[data-detected-swatch]');this.name=root.querySelector('[data-detected-name]');this.hex=root.querySelector('[data-detected-hex]');this.picker=root.querySelector('[data-picker]');this.mood='balanced';this.currentRgb=[190,180,170];this.products=[...root.querySelectorAll('[data-luma-product]')].map(el=>({name:el.dataset.name,hex:el.dataset.hex,url:el.dataset.url,price:el.dataset.price,image:el.dataset.image,rgb:this.hexToRgb(el.dataset.hex)}));this.image=new Image();this.input.addEventListener('change',e=>this.loadFile(e));root.querySelector('[data-retake]').addEventListener('click',()=>this.reset());root.querySelector('[data-again]').addEventListener('click',()=>{this.canvas.scrollIntoView({behavior:'smooth',block:'center'});this.flashLabel()});this.canvas.addEventListener('click',e=>this.pick(e));root.querySelectorAll('[data-mood]').forEach(b=>b.addEventListener('click',()=>this.setMood(b)))}
loadFile(e){const f=e.target.files&&e.target.files[0];if(!f||!f.type.startsWith('image/'))return;const u=URL.createObjectURL(f);this.image.onload=()=>{const m=1200,s=Math.min(1,m/Math.max(this.image.naturalWidth,this.image.naturalHeight));this.canvas.width=Math.round(this.image.naturalWidth*s);this.canvas.height=Math.round(this.image.naturalHeight*s);this.ctx.drawImage(this.image,0,0,this.canvas.width,this.canvas.height);URL.revokeObjectURL(u);this.upload.hidden=true;this.workspace.hidden=false;this.autoDetect();this.workspace.scrollIntoView({behavior:'smooth',block:'nearest'})};this.image.src=u}
reset(){this.input.value='';this.workspace.hidden=true;this.upload.hidden=false;this.results.innerHTML='';this.picker.classList.remove('is-visible');this.upload.scrollIntoView({behavior:'smooth',block:'center'})}
setMood(b){this.root.querySelectorAll('[data-mood]').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');this.mood=b.dataset.mood;this.render(this.rank(this.currentRgb))}
pick(e){const r=this.canvas.getBoundingClientRect(),px=e.clientX-r.left,py=e.clientY-r.top,x=Math.round(px*this.canvas.width/r.width),y=Math.round(py*this.canvas.height/r.height);this.picker.style.left=px+'px';this.picker.style.top=py+'px';this.picker.classList.add('is-visible');this.useColour(this.averagePatch(x,y,14))}
flashLabel(){const l=this.root.querySelector('.luma-match__photo-label');l.animate([{transform:'translateX(-50%) scale(1)'},{transform:'translateX(-50%) scale(1.08)'},{transform:'translateX(-50%) scale(1)'}],{duration:500})}
autoDetect(){const pts=[],sx=Math.max(1,Math.floor(this.canvas.width/32)),sy=Math.max(1,Math.floor(this.canvas.height/32)),x0=Math.floor(this.canvas.width*.18),x1=Math.floor(this.canvas.width*.82),y0=Math.floor(this.canvas.height*.16),y1=Math.floor(this.canvas.height*.9),d=this.ctx.getImageData(0,0,this.canvas.width,this.canvas.height).data;for(let y=y0;y<y1;y+=sy)for(let x=x0;x<x1;x+=sx){const i=(y*this.canvas.width+x)*4,rgb=[d[i],d[i+1],d[i+2]],h=this.rgbToHsl(rgb);if(h[2]>.94||h[2]<.08)continue;pts.push(rgb)}if(!pts.length)return this.useColour([190,180,170]);const bins=new Map;pts.forEach(rgb=>{const k=rgb.map(v=>Math.round(v/32)*32).join(','),a=bins.get(k)||{count:0,sum:[0,0,0]};a.count++;a.sum=a.sum.map((v,i)=>v+rgb[i]);bins.set(k,a)});const b=[...bins.values()].sort((a,b)=>b.count-a.count)[0];this.useColour(b.sum.map(v=>Math.round(v/b.count)))}
averagePatch(cx,cy,r){const x=Math.max(0,cx-r),y=Math.max(0,cy-r),w=Math.min(this.canvas.width-x,r*2+1),h=Math.min(this.canvas.height-y,r*2+1),d=this.ctx.getImageData(x,y,w,h).data,s=[0,0,0];let n=0;for(let i=0;i<d.length;i+=16){s[0]+=d[i];s[1]+=d[i+1];s[2]+=d[i+2];n++}return s.map(v=>Math.round(v/n))}
useColour(rgb){this.currentRgb=rgb;const hex=this.rgbToHex(rgb);this.swatch.style.background=hex;this.hex.textContent=hex.toUpperCase();this.name.textContent=this.describe(rgb);this.render(this.rank(rgb))}
rank(rgb){const s=this.rgbToHsl(rgb);return this.products.map(p=>{const h=this.rgbToHsl(p.rgb),hd=Math.min(Math.abs(s[0]-h[0]),1-Math.abs(s[0]-h[0])),ld=Math.abs(s[2]-h[2]),sd=Math.abs(s[1]-h[1]),neutral=h[1]<.16,tonal=hd<.075,comp=Math.abs(hd-.5),analog=Math.abs(hd-.10);let score;if(this.mood==='tonal')score=hd*1.4+ld*.45+sd*.08;else if(this.mood==='contrast')score=comp*1.4+Math.abs(ld-.28)*.18;else{score=Math.min(comp*1.15,analog*.85,hd*.72+ld*.24)+sd*.08;if(neutral)score-=.055;if(tonal&&ld<.12)score+=.08;if(s[2]>.72&&h[2]<.42)score-=.08;if(s[2]<.32&&h[2]>.55)score-=.06}return{...p,score}}).sort((a,b)=>a.score-b.score).slice(0,3)}
render(items){const labels=this.mood==='tonal'?['Closest tone','Soft harmony','Tonal option']:this.mood==='contrast'?['Best contrast','Statement match','Rich contrast']:['Best match','Beautiful contrast','Easy pairing'];this.results.innerHTML=items.map((p,i)=>`<a class="luma-match-card" href="${p.url}"><span class="luma-match-card__tag">${labels[i]}</span><span class="luma-match-card__image">${p.image?`<img src="${p.image}" alt="${p.name}" loading="lazy">`:`<span class="luma-match-card__fallback" style="background:${p.hex}"></span>`}</span><span class="luma-match-card__meta"><span class="luma-match-card__name"><i class="luma-match-card__swatch" style="background:${p.hex}"></i>${p.name}</span><span class="luma-match-card__price">${p.price}</span><span class="luma-match-card__shop">Shop this shade →</span></span></a>`).join('')}
describe(rgb){const h=this.rgbToHsl(rgb),a=h[0]*360,s=h[1],l=h[2];if(s<.12)return l>.82?'Soft neutral':l<.25?'Deep neutral':'Neutral tone';if(a<15||a>=345)return l<.45?'Deep red':'Warm rose';if(a<45)return l>.7?'Warm beige':'Warm earth';if(a<70)return l>.72?'Cream':'Golden neutral';if(a<165)return'Green tone';if(a<255)return l<.4?'Deep blue':'Cool blue';if(a<300)return'Soft violet';return'Rose tone'}
hexToRgb(h){const v=h.replace('#','');return[0,2,4].map(i=>parseInt(v.slice(i,i+2),16))}rgbToHex(rgb){return'#'+rgb.map(v=>Math.max(0,Math.min(255,v)).toString(16).padStart(2,'0')).join('')}rgbToHsl(rgb){let[r,g,b]=rgb.map(v=>v/255),max=Math.max(r,g,b),min=Math.min(r,g,b),h=0,s=0,l=(max+min)/2,d=max-min;if(d){s=l>.5?d/(2-max-min):d/(max+min);switch(max){case r:h=(g-b)/d+(g<b?6:0);break;case g:h=(b-r)/d+2;break;default:h=(r-g)/d+4}h/=6}return[h,s,l]}}
document.querySelectorAll('.luma-match').forEach(root=>{if(!root.dataset.lumaReady){root.dataset.lumaReady='true';new LumaColourMatch(root)}});

  } catch(e) { console.error(e); }
})();
})();
